import styled from 'styled-components';

const LogoStyle = styled.div`
	--sizeLogoHeight: 30px;
	--logoColor: var(--white1000);

	cursor: pointer;

	&.inverse {
		--logoColor: var(--black1000);
	}

	.inner-wrapper-logo {
		display: flex;
		svg {
			height: var(--sizeLogoHeight);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		.inner-wrapper-logo {
			display: flex;
			svg {
				height: var(--sizeLogoHeight);
			}
		}
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;
export default LogoStyle;
